export function terminalColumnLabel(systemType) {
  if (systemType === 'WON') return 'Успешно'
  if (systemType === 'LOST') return 'Неуспешно'
  return null
}

export function archiveOutcomeLabel(outcome) {
  if (outcome === 'WON') return 'Успешно'
  if (outcome === 'LOST') return 'Неуспешно'
  return 'В работе'
}

export const ARCHIVE_DELETE_ONE_LABEL = 'Удалить навсегда'
export const ARCHIVE_DELETE_ALL_LABEL = 'Удалить навсегда все'

export function buildBoardDeletionMappings(columns, destinations) {
  return columns.filter(column => column.total > 0).map(column => ({
    sourceColumnId: column.id,
    targetBoardId: destinations[column.id]?.boardId || null,
    ...(column.systemType === 'NORMAL' ? { targetColumnId: destinations[column.id]?.columnId || null } : {}),
  }))
}

export function boardDeletionMappingsComplete(mappings) {
  return mappings.every(mapping => mapping.targetBoardId && (!('targetColumnId' in mapping) || mapping.targetColumnId))
}

function plural(count, one, few, many) {
  const remainder = Math.abs(Number(count)) % 100
  const last = remainder % 10
  if (remainder > 10 && remainder < 20) return many
  if (last > 1 && last < 5) return few
  if (last === 1) return one
  return many
}

export function requestCountLabel(total, archived = 0) {
  const totalLabel = `${total} ${plural(total, 'заявка', 'заявки', 'заявок')}`
  if (!archived) return totalLabel
  return `${totalLabel} (${archived} ${plural(archived, 'в архиве', 'в архиве', 'в архиве')})`
}

export function terminalMigrationTargetLabel(systemType, targetBoard) {
  const targetColumn = targetBoard?.columns?.find(column => column.systemType === systemType)
  if (targetColumn) return `Будет перенесена в «${targetColumn.name}».`
  return systemType === 'WON'
    ? 'Будет перенесена в колонку успешных заявок выбранной доски.'
    : 'Будет перенесена в колонку неуспешных заявок выбранной доски.'
}
